<template>
    <v-layout class="overflow-visible" style="height: 56px;">
        <v-bottom-navigation v-model="value" color="primary" active>
            <v-btn to="/">
                <v-icon>mdi-calculator</v-icon>

                Calculator
            </v-btn>

            <v-btn to="/esercizi">
                <v-icon>mdi-lan</v-icon>

                Exercises
            </v-btn>

            
        </v-bottom-navigation>
    </v-layout>
</template>
<script>
export default {    
  name: 'BottomNav',
  data() {
    return {
      value: null,
    };
  },
};
</script>